import React, { FC } from 'react'

import { css, cx } from '@linaria/core'
import { styled } from '@linaria/react'

import { Online } from 'components/designSystem/Status/Online'
import { Verification } from 'components/designSystem/Status/Verification'

/**
 * inline-status - статус-иконка без текста
 * footer-status - статус-иконка с текстом
 * badge-status - статус-иконки при скроллинге на mobile
 */

export const StatusVariants: FC<{
  size: 'micro' | 'mini'
  isOnline?: boolean
  isVerified?: boolean
  variant?: 'footer-status' | 'badge-status'
}> = ({ variant, size, isOnline, isVerified }) => {
  if (!isVerified && !isOnline) {
    return null
  }

  const isMini = isOnline && isVerified && size === 'mini'
  const isMicro = isOnline && isVerified && size === 'micro'
  const isFooterStatus = variant === 'footer-status'

  const isBadgeStatus = variant === 'badge-status'

  return (
    <Parent
      className={cx(
        isMini && miniGapCss,
        isMicro && microGapCss,
        isFooterStatus && statusWithTextCss,
        isBadgeStatus && badgeCss
      )}
    >
      {isVerified && (
        <Verification
          variant={variant}
          size={sizeMap[size].verification.width}
        />
      )}
      {isOnline && (
        <Online
          variant={variant}
          size={sizeMap[size].online.width}
          isVerified={isVerified}
        />
      )}
    </Parent>
  )
}

const Parent = styled.span`
  display: inline-grid;
  grid-template-columns: repeat(2, auto);
  align-items: center;
  vertical-align: top;
`

const miniGapCss = css`
  grid-gap: var(--spacing-4px);
  gap: var(--spacing-4px);
`

const microGapCss = css`
  grid-gap: var(--spacing-2px);
  gap: var(--spacing-2px);
`

const statusWithTextCss = css`
  max-width: fit-content;
  grid-gap: var(--spacing-8px);
  gap: var(--spacing-8px);
`

const badgeCss = css`
  padding: var(--spacing-6px);
  vertical-align: top;
  align-items: center;
  border-radius: var(--spacing-20px);
  background: var(--warm-opacity-default);
  backdrop-filter: blur(12px);
`

const sizeMap = {
  mini: {
    online: {
      width: 12,
      height: 12,
    },
    verification: {
      width: 24,
      height: 24,
    },
  },
  micro: {
    online: {
      width: 8,
      height: 8,
    },
    verification: {
      width: 16,
      height: 16,
    },
  },
} as const
